/**
 * @kantera/i18n — shared locale resources + i18next runtime initializers.
 *
 * One source of truth for both web (initI18n) and mobile (initMobileI18n).
 * Mobile previously kept its own subset of locale JSON; that copy is gone —
 * mobile now consumes the same en.json / es.json the web app uses.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
export const SUPPORTED_LOCALES = ['en', 'es'];
const baseResources = {
    en: { translation: enTranslations },
    es: { translation: esTranslations },
};
const baseInterpolation = {
    escapeValue: false, // React + React Native both escape XSS
};
/**
 * Initialize i18next for web (DOM) applications. Call once at app startup
 * before rendering any component that uses useTranslation().
 */
export function initI18n(defaultLanguage = 'en') {
    if (i18n.isInitialized) {
        return i18n;
    }
    void i18n.use(initReactI18next).init({
        resources: baseResources,
        lng: defaultLanguage,
        fallbackLng: 'en',
        interpolation: baseInterpolation,
        ns: ['translation'],
        defaultNS: 'translation',
    });
    return i18n;
}
/**
 * Initialize i18next for the mobile (React Native) app. Disables Suspense
 * because RN intentionally lacks DOM helpers.
 */
export function initMobileI18n(defaultLanguage = 'en') {
    if (i18n.isInitialized) {
        return i18n;
    }
    void i18n.use(initReactI18next).init({
        resources: baseResources,
        lng: defaultLanguage,
        fallbackLng: 'en',
        interpolation: baseInterpolation,
        ns: ['translation'],
        defaultNS: 'translation',
        react: { useSuspense: false },
    });
    return i18n;
}
export { i18n };
export { useIntl } from './useIntl.js';
export { useTranslationTyped } from './useTranslationTyped.js';
//# sourceMappingURL=index.js.map